<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :url="url"
                      :operate="operate"
                      :form-fields="formFields"
                      :searchs="searchs"
                      :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "UserIp",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                    {
                        name: 'phone',
                        placeholder: '用户',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{},
                url: {
                    get: '/userIp/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }, {
                    field: 'ip',
                    label: 'IP地址',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '180px',
                }],
                operate: [],
                formFields: {model: [],
                }
            }
        }
    }
</script>

<style scoped>

</style>
